import { TrendingUp, Gem, CalendarDays, Users, Heart, PawPrint, Sparkles, Zap } from "lucide-react";

// Single source of truth for villa category filters — shared by the navbar
// CategoryBar and the Search page's sidebar filters.
export const CATEGORIES = [
  { id: "trending", label: "Trending", Icon: TrendingUp },
  { id: "luxury", label: "Luxury", Icon: Gem },
  { id: "weekend", label: "Weekend", Icon: CalendarDays },
  { id: "family", label: "Family", Icon: Users },
  { id: "couple", label: "Couple", Icon: Heart },
  { id: "pet", label: "Pet-friendly", Icon: PawPrint },
  { id: "new", label: "New", Icon: Sparkles },
  { id: "lastminute", label: "Last-minute", Icon: Zap },
];
